// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Xn5Ez","cell":"ColumnAccessor_cell__X5G09","firstCellAccent":"ColumnAccessor_firstCellAccent__3a30f"};